export * from 'server/models/DispatchEventDetailsBilling';


// WEBPACK FOOTER //
// ./data/models/DispatchEventDetailsBilling.ts